export const manifest = {
  screens: {
    scr_ksm40j: { name: "Anmeldung", route: "/", state: {"screen":"login"}, position: {"x":160,"y":220} },
    scr_u5yv10: { name: "Produktionsmenü", route: "/", state: {"screen":"production"}, position: {"x":1560,"y":220} },
    scr_yzgpjr: { name: "Geplante Aufträge", route: "/", state: {"screen":"production","view":"planned-orders"}, position: {"x":160,"y":2200} },
    scr_ejfkpa: { name: "Aktuell", route: "/", state: {"screen":"office","officeSection":"running-orders"}, position: {"x":160,"y":4180} },
    scr_qjetrt: { name: "Benutzerverwaltung", route: "/", state: {"screen":"office","officeSection":"users"}, position: {"x":160,"y":6160} },
    scr_ssrg64: { name: "Rohstoffe", route: "/", state: {"screen":"office","officeSection":"materials"}, position: {"x":160,"y":8140} },
    scr_ztl93g: { name: "Produktionsplaner", route: "/", state: {"screen":"office","officeSection":"planner"}, position: {"x":1560,"y":4180} },
    scr_foapy6: { name: "Abgeschlossen", route: "/", state: {"screen":"office","officeSection":"running-orders","orderView":"completed"}, position: {"x":1560,"y":2200} },
  },
  sections: {
    sec_l48c51: { name: "Authentication & Entry", x: 0, y: 0, width: 2920, height: 1180 },
    sec_0nwbvg: { name: "Order Management", x: 0, y: 1980, width: 2920, height: 1180 },
    sec_69hvj2: { name: "Dashboard & Overview", x: 0, y: 3960, width: 2920, height: 1180 },
    sec_9438sw: { name: "Admin & Settings", x: 0, y: 5940, width: 1520, height: 1180 },
    sec_hlv5po: { name: "Materials & Inventory", x: 0, y: 7920, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_l48c51", children: [
      { kind: "screen", id: "scr_ksm40j" },
      { kind: "screen", id: "scr_u5yv10" },
    ] },
    { kind: "section", id: "sec_0nwbvg", children: [
      { kind: "screen", id: "scr_yzgpjr" },
      { kind: "screen", id: "scr_foapy6" },
    ] },
    { kind: "section", id: "sec_69hvj2", children: [
      { kind: "screen", id: "scr_ejfkpa" },
      { kind: "screen", id: "scr_ztl93g" },
    ] },
    { kind: "section", id: "sec_9438sw", children: [
      { kind: "screen", id: "scr_qjetrt" },
    ] },
    { kind: "section", id: "sec_hlv5po", children: [
      { kind: "screen", id: "scr_ssrg64" },
    ] },
  ],
}
